export interface ClientConfig {
  messagingApiUrl: string;
  messagingClientUrl: string;
  mainApiUrl: string;
  adminApiUrl: string;
  contactCenterApiUrl: string;
}

// VITE_ vars are baked in at build time — used as fallback for local dev
// and as a safety net if the config endpoint is unreachable.
const defaults: ClientConfig = {
  messagingApiUrl:     import.meta.env.VITE_MESSAGING_API_URL     ?? "",
  messagingClientUrl:  import.meta.env.VITE_MESSAGING_CLIENT_URL  ?? "",
  mainApiUrl:          import.meta.env.VITE_MAIN_API_URL          ?? "",
  adminApiUrl:         import.meta.env.VITE_ADMIN_API_URL         ?? "",
  contactCenterApiUrl: import.meta.env.VITE_CONTACTCENTER_API_URL ?? "",
};

let config: ClientConfig = { ...defaults };

export async function loadClientConfig(): Promise<void> {
  try {
    const res = await fetch("/api/client-config");
    if (res.ok) {
      const data = await res.json();
      config = { ...defaults, ...data };
    }
  } catch {
    // Unreachable in prod (same origin). Falls back to baked-in VITE_ defaults.
  }
}

export function getClientConfig(): ClientConfig {
  return config;
}
